// extracted by mini-css-extract-plugin
export var list = "Tags-module--list--fv3Hp";
export var list__item = "Tags-module--list__item--3vs6p";